<template>
  <li class="list-group-item">
    <router-link tag="a" :to="{name: name}">{{ displayedTitle }}</router-link>
  </li>
</template>


<script>
export default {
  name: "ApplicationMenuDropdownItem",
  props: {
    name: { type: String, default: "" },
    title: { type: String, default: "" }
  },
  computed: {
    displayedTitle() {
      return this.title.length ? this.title : this.name;
    }
  }
};
</script>
<style scoped>
a {
  font-size: 0.875rem !important;
}
</style>
